export const RefundPolicyText =
    'All payments made are final and strictly non-refundable under any circumstances. ' +
    'Once a transaction has been completed, no refunds, exchanges, or cancellations will be permitted, ' +
    'regardless of changes in circumstances, non-usage, or dissatisfaction. ' +
    'By proceeding with the purchase, the customer acknowledges and agrees to this non-refundable policy in full.';
